import React, { useState } from 'react';
import logo from "../assets/rxultimate.png";
import { 
  FaFacebook, 
  FaTwitter, 
  FaInstagram, 
  FaLinkedin, 
  FaPhoneAlt, 
  FaMapMarkerAlt, 
  FaEnvelope,
  FaArrowUp,
  FaGlobe,
  FaHeartbeat,
  FaPrescriptionBottleAlt,
  FaUserMd,
  FaShieldAlt,
  FaRegCopyright
} from 'react-icons/fa';

const Footer = () => {
  const [email, setEmail] = useState('');
  const [subscribed, setSubscribed] = useState(false);

  const handleSubscribe = (e) => {
    e.preventDefault();
    if (email) {
      setSubscribed(true);
      setTimeout(() => {
        setSubscribed(false);
        setEmail('');
      }, 3000);
    }
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-gradient-to-b from-white to-emerald-50 relative">
      {/* Top Wave Design */}
      <div className="absolute top-0 left-0 w-full overflow-hidden leading-0 transform -translate-y-1/2">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1200 120" preserveAspectRatio="none" className="h-12 w-full text-emerald-50">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="currentColor"></path>
        </svg>
      </div>

      {/* Back to Top Button */}
      <button 
        onClick={scrollToTop}
        className="absolute top-4 right-8 bg-white rounded-full p-3 shadow-lg hover:shadow-xl transform hover:-translate-y-1 transition-all duration-300 text-emerald-600 hover:text-emerald-700 focus:outline-none"
        aria-label="Back to top"
      >
        <FaArrowUp className="w-5 h-5" />
      </button>
      
      {/* Main Footer Content */}
      <div className="container mx-auto px-4 pt-16 pb-8">
        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 mb-12">
          {/* Column 1 - About */}
          <div>
            <div className="mb-6 flex items-center">
              <img src={logo} alt="RXUltimate Logo" className="h-12 mr-3" />
              <h2 className="text-xl font-bold text-gray-800">RXUltimate</h2>
            </div>
            <p className="text-gray-600 mb-6">
              Your trusted pharmacy management solution. Streamlining operations, enhancing patient care, and boosting efficiency for modern pharmacies.
            </p>
            <div className="flex space-x-4">
              <a href="#" className="bg-white p-2 rounded-full shadow-md transition-all duration-300 hover:bg-emerald-100 hover:text-emerald-600 text-gray-600">
                <FaFacebook className="w-5 h-5" />
              </a>
              <a href="#" className="bg-white p-2 rounded-full shadow-md transition-all duration-300 hover:bg-emerald-100 hover:text-emerald-600 text-gray-600">
                <FaTwitter className="w-5 h-5" />
              </a>
              <a href="#" className="bg-white p-2 rounded-full shadow-md transition-all duration-300 hover:bg-emerald-100 hover:text-emerald-600 text-gray-600">
                <FaInstagram className="w-5 h-5" />
              </a>
              <a href="#" className="bg-white p-2 rounded-full shadow-md transition-all duration-300 hover:bg-emerald-100 hover:text-emerald-600 text-gray-600">
                <FaLinkedin className="w-5 h-5" />
              </a>
            </div>
          </div>
          
          {/* Column 2 - Quick Links */}
          <div>
            <h3 className="text-lg font-bold text-gray-800 mb-6 flex items-center">
              <FaGlobe className="mr-2 text-emerald-600" /> Quick Links
            </h3>
            <ul className="space-y-3">
              {['Home', 'About Us', 'Services', 'Contact', 'FAQs'].map((link) => (
                <li key={link}>
                  <a 
                    href="#" 
                    className="text-gray-600 hover:text-emerald-600 transition-colors duration-300 flex items-center"
                  >
                    <span className="inline-block w-2 h-2 bg-emerald-400 rounded-full mr-2 transition-all duration-300"></span>
                    {link}
                  </a>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Column 3 - Features */}
          <div>
            <h3 className="text-lg font-bold text-gray-800 mb-6 flex items-center">
              <FaHeartbeat className="mr-2 text-emerald-600" /> Our Features
            </h3>
            <ul className="space-y-4">
              {[
                { icon: <FaPrescriptionBottleAlt />, text: 'Prescription Management' },
                { icon: <FaShieldAlt />, text: 'Secure Patient Data' },
                { icon: <FaUserMd />, text: 'Provider Portal' },
                { icon: <FaHeartbeat />, text: 'Patient Engagement' }
              ].map((feature, index) => (
                <li key={index} className="flex items-start">
                  <span className="bg-emerald-100 p-2 rounded-md text-emerald-600 mr-3">
                    {feature.icon}
                  </span>
                  <span className="text-gray-600">{feature.text}</span>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Column 4 - Newsletter */}
          <div>
            <h3 className="text-lg font-bold text-gray-800 mb-6 flex items-center">
              <FaEnvelope className="mr-2 text-emerald-600" /> Newsletter
            </h3>
            <p className="text-gray-600 mb-4">
              Subscribe to our newsletter to receive updates and pharmacy management tips.
            </p>
            
            {subscribed ? (
              <div className="bg-emerald-100 border border-emerald-200 text-emerald-700 p-3 rounded animate-pulse mb-4">
                Thank you for subscribing!
              </div>
            ) : (
              <form onSubmit={handleSubscribe} className="mb-6">
                <div className="flex">
                  <input 
                    type="email" 
                    placeholder="Your email address" 
                    className="flex-grow px-4 py-2 rounded-l-md border border-gray-300 focus:ring-2 focus:ring-emerald-300 focus:border-emerald-300 transition-all duration-300"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    required
                  />
                  <button 
                    type="submit" 
                    className="bg-emerald-600 hover:bg-emerald-700 text-white px-4 py-2 rounded-r-md transition-colors duration-300"
                  >
                    Subscribe
                  </button>
                </div>
              </form>
            )}
            
            <div className="space-y-3">
              <div className="flex items-start">
                <FaPhoneAlt className="text-emerald-600 mr-3 mt-1" />
                <span className="text-gray-600">(+233) 541-548-7965</span>
              </div>
              <div className="flex items-start">
                <FaEnvelope className="text-emerald-600 mr-3 mt-1" />
                <span className="text-gray-600">info@rxultimate.com</span>
              </div>
              <div className="flex items-start">
                <FaMapMarkerAlt className="text-emerald-600 mr-3 mt-1" />
                <span className="text-gray-600">Accra, Ghana</span>
              </div>
            </div>
          </div>
        </div>
        
        {/* Divider */}
        <div className="h-px bg-gradient-to-r from-transparent via-emerald-200 to-transparent mb-6"></div>
        
        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center text-gray-600">
            <FaRegCopyright className="mr-1" /> {currentYear} RXUltimate. All rights reserved.
          </div>
          
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-gray-600">
            <a href="#" className="hover:text-emerald-600 transition-colors duration-300">Privacy Policy</a>
            <a href="#" className="hover:text-emerald-600 transition-colors duration-300">Terms of Service</a>
            <a href="#" className="hover:text-emerald-600 transition-colors duration-300">Cookies Policy</a>
            <a href="#" className="hover:text-emerald-600 transition-colors duration-300">Sitemap</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;